
// https://codepen.io/ddaversa/pen/WvvZPP
import { Component, Vue } from 'vue-property-decorator'

@Component({})
export default class BacEllipsisLoader extends Vue {}
